module.exports = __webpack_public_path__ + "media/shared/assets/fonts/Inter-Italic-c52bf90bf478701f3d4f5950041ca78f.woff";